import { render, staticRenderFns } from "./CategorySearchModal.vue?vue&type=template&id=2aa279f3&scoped=true&"
import script from "./CategorySearchModal.vue?vue&type=script&lang=js&"
export * from "./CategorySearchModal.vue?vue&type=script&lang=js&"
import style0 from "./CategorySearchModal.vue?vue&type=style&index=0&id=2aa279f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa279f3",
  null
  
)

export default component.exports